/* Raven full bundle offer card (v4, 2026-09-23).
   One click adds: chosen Raven color + hidden "Raven Full Bundle Gear" product (+ Metal Finish add-on for Brick).
   Prices are the real product prices; this file only displays them. */
(function () {
  'use strict';

  // Builds a formatter from the theme's own money filter output for 123456 cents (e.g. "$1,234.56",
  // "€1.234,56", "1 234,56 €", "¥1,235"), so prices this script updates look exactly like Liquid's.
  function moneyFormatter(sample) {
    var m = /^([^\d]*)(\d[\d.,'\u2019\u00a0 ]*\d)([^\d]*)$/.exec(String(sample || '').trim());
    if (!m) return null;
    var pre = m[1], num = m[2], suf = m[3];
    var hasDec = num.replace(/\D/g, '') === '123456';
    var dec = hasDec ? num.charAt(num.length - 3) : '';
    var grp = /\d/.test(num.charAt(1)) ? '' : num.charAt(1);
    return function (cents) {
      var v = hasDec ? (Math.round(cents) / 100).toFixed(2) : String(Math.round(cents / 100));
      var parts = v.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, grp);
      return pre + whole + (hasDec ? dec + parts[1] : '') + suf;
    };
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var cfg = JSON.parse(root.querySelector('[data-gbfb-config]').textContent);
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-gbfb-sw]'));
    var group = root.querySelector('[data-gbfb-swatches]');
    var finish = root.querySelector('[data-gbfb-finish]');
    var finishRow = root.querySelector('[data-gbfb-finish-row]');
    var cta = root.querySelector('[data-gbfb-cta]');
    var ctaText = root.querySelector('[data-gbfb-cta-text]');
    var errorBox = root.querySelector('[data-gbfb-error]');
    var busy = false;
    var fmt = moneyFormatter(cfg.moneySample);

    function money(cents) {
      return fmt ? fmt(cents) : (cents / 100).toFixed(2);
    }
    function set(sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    }
    function current() {
      for (var i = 0; i < swatches.length; i++) {
        if (swatches[i].getAttribute('aria-checked') === 'true') return swatches[i];
      }
      return swatches[0];
    }
    function finishAllowed(sw) {
      return cfg.finishVariantId > 0 && cfg.finishVariants.indexOf(Number(sw.dataset.id)) !== -1;
    }
    function finishOn() {
      return !!(finish && finish.checked && finishAllowed(current()));
    }
    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg || '';
      errorBox.hidden = !msg;
    }
    function select(sw) {
      if (!sw || sw.disabled) return;
      swatches.forEach(function (b) {
        var on = b === sw;
        b.setAttribute('aria-checked', String(on));
        b.tabIndex = on ? 0 : -1;
      });
      update();
    }

    function update() {
      var sw = current();
      if (!sw) return;
      var allowed = finishAllowed(sw);
      if (finishRow) finishRow.hidden = !allowed;
      if (finish && !allowed) finish.checked = false;
      var on = finishOn();
      if (finishRow) finishRow.classList.toggle('is-on', on);

      var extra = on ? cfg.finishPrice : 0;
      var raven = Number(sw.dataset.price);
      var total = raven + cfg.gearPrice + extra;
      var value = raven + cfg.extrasPrice + extra;
      var save = value > total ? Math.floor(((value - total) * 100) / value) : 0;

      set('[data-gbfb-total]', money(total));
      set('[data-gbfb-value]', money(value));
      var saveEl = root.querySelector('[data-gbfb-save]');
      if (saveEl) {
        saveEl.textContent = 'Save ' + save + '%';
        saveEl.hidden = save < 1;
      }
      set('[data-gbfb-color-name]', sw.dataset.name);
      var shown = root.querySelector('[data-gbfb-shown]');
      if (shown) shown.hidden = Number(sw.dataset.id) === cfg.pictureVariant;
      set('[data-gbfb-first]', 'Raven ' + sw.dataset.name + (sw.dataset.kit === 'brick' ? ' + stand + bricks' : ' blaster'));
      showError('');
    }

    function lines() {
      var list = [
        [Number(current().dataset.id)],
        [cfg.gearVariantId, { _gb_bundle: 'raven-full-bundle' }]
      ];
      if (finishOn()) list.push([cfg.finishVariantId]);
      return list;
    }

    function done() {
      busy = false;
      cta.disabled = false;
      cta.classList.remove('is-loading');
      if (ctaText) ctaText.textContent = 'Get the full bundle';
    }

    // Same route as the theme's own add to cart (FormData to cart_add_url + sections), so the Club opt-in,
    // gift checks and pre-purchase upsell react exactly like after a normal add. Never run inside
    // GBCart.queueMutation (the Club hook waits for GBCart to be idle).
    function addToCart() {
      if (busy) return;
      busy = true;
      showError('');
      cta.disabled = true;
      cta.classList.add('is-loading');
      if (ctaText) ctaText.textContent = 'Adding…';

      var drawer = document.querySelector('cart-drawer');
      var ravenId = Number(current().dataset.id);
      var idle = window.GBCart && typeof window.GBCart.whenIdle === 'function' ? window.GBCart.whenIdle() : null;

      Promise.resolve(idle)
        .catch(function () {})
        .then(function () {
          var fd = new FormData();
          lines().forEach(function (line, i) {
            fd.append('items[' + i + '][id]', line[0]);
            fd.append('items[' + i + '][quantity]', '1');
            var props = line[1] || {};
            Object.keys(props).forEach(function (k) {
              fd.append('items[' + i + '][properties][' + k + ']', props[k]);
            });
          });
          var sections = drawer && typeof drawer.getSectionsToRender === 'function'
            ? drawer.getSectionsToRender().map(function (x) { return x.id; })
            : ['cart-drawer', 'cart-icon-bubble'];
          fd.append('sections', sections.join(','));
          fd.append('sections_url', window.location.pathname);
          return fetch(cfg.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
          });
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!data || data.status) {
            throw new Error((data && (data.description || data.message)) || 'Could not add the bundle.');
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: ravenId, cartData: data });
          }
          if (drawer && typeof drawer.renderContents === 'function') {
            // Same as the theme's product form: an empty drawer must lose "is-empty" before it re-renders,
            // otherwise its focus trap looks for the old empty-state node.
            drawer.classList.remove('is-empty');
            if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(cta);
            drawer.renderContents(data);
          } else {
            window.location.href = cfg.cartUrl;
          }
          done();
        })
        .catch(function (err) {
          done();
          showError((err && err.message) || 'Could not add the bundle. Please try again.');
          if (window.GBCart && typeof window.GBCart.readCart === 'function') {
            try { window.GBCart.readCart(true); } catch (e) {}
          }
        });
    }

    swatches.forEach(function (b) {
      b.addEventListener('click', function () { select(b); });
    });

    if (group) {
      group.addEventListener('keydown', function (e) {
        var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        if (!keys[e.key]) return;
        e.preventDefault();
        var enabled = swatches.filter(function (b) { return !b.disabled; });
        var i = enabled.indexOf(current());
        var next = enabled[(i + keys[e.key] + enabled.length) % enabled.length];
        select(next);
        next.focus();
      });
    }

    if (finish) finish.addEventListener('change', update);
    if (cta) cta.addEventListener('click', addToCart);

    update();
  }

  function boot() {
    document.querySelectorAll('[data-gbfb]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
